import { render, staticRenderFns } from "./about-us.vue?vue&type=template&id=667d3755&scoped=true&"
import script from "./about-us.vue?vue&type=script&lang=js&"
export * from "./about-us.vue?vue&type=script&lang=js&"
import style0 from "./about-us.vue?vue&type=style&index=0&id=667d3755&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d3755",
  null
  
)

export default component.exports